var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayscale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 12c0 4.4 3.6 8 8 8h3v-16h-3c-4.4 0-8 3.6-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 6h7v2h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 16h7v2h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 11h7v2h-7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayscale);
export default __webpack_public_path__ + "static/media/Grayscale.badc0206f21fbd729d36fe0932406a26.svg";
export { ForwardRef as ReactComponent };